// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';
var DEFAULT_COLUMN_CONFIG = new ColumnConfig();
export var getCellError = function getCellError() {
  var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COLUMN_CONFIG;
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var columnId = columnConfig.getColumnId();
  var cellError = errors[columnId];
  return cellError;
};